import axios from "axios";

const storefrontProxyUrl = process.env.REACT_APP_STOREFRONT_PROXY_URL;

export async function getAllCategories() {
    try {
        const response = await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/categories`, {
            params: {
                include_fields: 'category_id,parent_id,name',
                is_visible: 'true',
            },
            headers: {
                'Accept': 'application/json'
            }
        });

        const rawCategories = response.data.data;

        // Step 1: Normalize and map categories by ID
        const categoryMap = {};
        rawCategories.forEach((cat) => {
            categoryMap[cat.category_id] = {
                id: cat.category_id,
                value: parseInt(cat.category_id),
                label: cat.name,
                children: null,
                parent_id: cat.parent_id,
            };
        });

        // Step 2: Build the tree by linking children to parents
        const categoryTree = [];
        Object.values(categoryMap).forEach((category) => {
            if (category.parent_id === 0) {
                categoryTree.push(category);
            } else {
                const parent = categoryMap[category.parent_id];
                if (parent) {
                    if (!parent.children)
                        parent.children = [];
                    parent.children.push(category);
                } else {
                    console.info(
                        `Cannot find the parent (${category.parent_id}) of the category (${category.id}) - ${category.label}`
                    );
                }
            }
        });

        // Step 3: Recursively sort all categories by label
        function sortCategoriesByLabel(categories) {
            categories.sort((a, b) => a.label.localeCompare(b.label));
            categories.forEach((category) => {
                if (category.children && category.children.length > 0) {
                    sortCategoriesByLabel(category.children);
                }
            });
        }

        sortCategoriesByLabel(categoryTree);

        return categoryTree; // Final result
    } catch (error) {
        console.error('Failed to fetch categories:', error.message);
        return [];
    }
}

/*export async function getAllCategories() {
    let categories = [];
    await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/categories`, {
        params: {include_fields: 'parent_id,name', is_visible: 'true'},
        headers: AUTH_HEADER /*{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Auth-Token': authToken
        }*/
/*    }).then(response => {
        const rawCategories = response.data.data;
        // Sort the categories with parent_id to prepare the root elements first
        rawCategories.sort((a, b) => parseInt(a.parent_id) - parseInt(b.parent_id));
        rawCategories.forEach((category) => {
            if (parseInt(category.parent_id) === 0) {
                category.id = category.category_id;
                category.value = parseInt(category.category_id);
                category.label = category.name;
                delete category.name;
                delete category.category_id;
                delete category.parent_id;
                categories.push(category); // Level 1
            } else {
                let found = false;
                categories.forEach((foundCategory) => {
                    if (parseInt(foundCategory.id) === parseInt(category.parent_id)) {
                        found = true;
                        if (!foundCategory.children)
                            foundCategory.children = [];
                        category.id = category.category_id;
                        category.value = parseInt(category.category_id);
                        category.label = category.name;
                        delete category.name;
                        delete category.category_id;
                        delete category.parent_id;
                        foundCategory.children.push(category); // Level 2
                    }
                });
                if (!found) {
                    let foundSub = false;
                    categories.forEach((foundSubCategory) => {
                        if (parseInt(foundSubCategory.id) === parseInt(category.parent_id)) {
                            foundSub = true;
                            if (!foundSubCategory.children)
                                foundSubCategory.children = [];
                            category.id = category.category_id;
                            category.value = parseInt(category.category_id);
                            category.label = category.name;
                            delete category.name;
                            delete category.category_id;
                            delete category.parent_id;
                            foundSubCategory.children.push(category); // Level 3
                        }
                    });
                    if (!foundSub)
                        console.info('Cannot find the parent (' + category.parent_id + ') of the category (' + category.category_id + ') - ' + category.name);
                }
            }
        });

        // Sort all categories and sub-categories in alphabetic order of the Label
        if (categories) {
            categories.sort((a, b) => a.label > b.label ? 1 : -1);
            categories.forEach((category) => {
                if (category.children) {
                    category.children.sort((a, b) => a.label > b.label ? 1 : -1);
                    category.children.forEach((subCategory) => {
                        if (subCategory.children) {
                            subCategory.children.sort((a, b) => a.label > b.label ? 1 : -1);
                        }
                    });
                }
            });
        }
    }).catch(console.error);

    return categories;
}*/